import React from "react";
import Model from "../Model";
import tw from "tailwind-styled-components";
import { DeleteBtn, SideCancelBtn, SubmitBtn } from "../Styles/InputStyles";

const DeleteProperty = ({
    setIsDeleteProperty,
    selectedData,
    deletePropertyLoading,
    deletePropertyMutate,
}) => {
    const handleDeleteSubmit = () => {
        deletePropertyMutate({ propId: selectedData?.id });
    };
    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setIsDeleteProperty}
            title="Confirm Delete"
        >
            <WarningText>
                Are you sure you want to delete this property? This action cannot be undone
            </WarningText>

            <div className="w-full flex justify-between space-x-6 my-4">
                <SideCancelBtn
                    type="button"
                    onClick={() => setIsDeleteProperty(false)}
                >
                    Cancel
                </SideCancelBtn>
                <DeleteBtn
                    onClick={handleDeleteSubmit}
                    disabled={deletePropertyLoading}
                    className="border border-red-500 bg-white text-red-500 hover:bg-red-500 hover:text-white"
                >
                    {deletePropertyLoading ? "Deleting..." : "Delete"}
                </DeleteBtn>
            </div>
        </Model>
    );
};
const WarningText = tw.p`text-gray-500 text-base mb-4`;
export default DeleteProperty;
